import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "@actions/actionCreators";

type Args = {
  spaceId: number;
  id: string;
};

const [useDeleteMarket, deleteMarket] = createAsyncAction(
  "markets/delete",
  async ({ spaceId, id }: Args) => {
    const res = await API.call<{ market: number }>({
      endpoint: `spaces/${spaceId}/markets/${id}`,
      method: "DELETE",
    });
    return { ...res, result: res.result.market };
  }
);

export default useDeleteMarket;
export { deleteMarket };
